"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var system_1 = require("../system");
var utils_1 = require("../utils");
var useStyles = (0, system_1.createUseStyles)({
    container: function (_a) {
        var display = _a.display, justifyContent = _a.justifyContent, alignItems = _a.alignItems, alignSelf = _a.alignSelf, alignContent = _a.alignContent, flexGrow = _a.flexGrow, flexShrink = _a.flexShrink, flex = _a.flex, flexWrap = _a.flexWrap, flexDirection = _a.flexDirection;
        return ({
            display: display,
            justifyContent: justifyContent,
            alignItems: alignItems,
            alignSelf: alignSelf,
            alignContent: alignContent,
            flexGrow: flexGrow,
            flexShrink: flexShrink,
            flex: flex,
            flexWrap: flexWrap,
            flexDirection: flexDirection,
        });
    },
    box: {
        '&$container': {
            margin: function (_a) {
                var m = _a.m;
                return (m === undefined ? undefined : (0, utils_1.calcSpace)(m));
            },
            marginTop: function (_a) {
                var mt = _a.mt;
                return (mt === undefined ? undefined : (0, utils_1.calcSpace)(mt));
            },
            marginBottom: function (_a) {
                var mb = _a.mb;
                return (mb === undefined ? undefined : (0, utils_1.calcSpace)(mb));
            },
            padding: function (_a) {
                var p = _a.p;
                return (p === undefined ? undefined : (0, utils_1.calcSpace)(p));
            },
            paddingTop: function (_a) {
                var pt = _a.pt;
                return (pt === undefined ? undefined : (0, utils_1.calcSpace)(pt));
            },
            paddingBottom: function (_a) {
                var pb = _a.pb;
                return (pb === undefined ? undefined : (0, utils_1.calcSpace)(pb));
            },
            marginRight: function (_a) {
                var mr = _a.mr;
                return (mr === undefined ? undefined : (0, utils_1.calcSpace)(mr));
            },
            marginLeft: function (_a) {
                var ml = _a.ml;
                return (ml === undefined ? undefined : (0, utils_1.calcSpace)(ml));
            },
            paddingRight: function (_a) {
                var pr = _a.pr;
                return (pr === undefined ? undefined : (0, utils_1.calcSpace)(pr));
            },
            paddingLeft: function (_a) {
                var pl = _a.pl;
                return (pl === undefined ? undefined : (0, utils_1.calcSpace)(pl));
            },
        },
    },
});
exports.Box = react_1.default.forwardRef(function Box(props, ref) {
    var _a = props.component, component = _a === void 0 ? 'div' : _a, _b = props.display, display = _b === void 0 ? 'flex' : _b, justifyContent = props.justifyContent, alignItems = props.alignItems, alignSelf = props.alignSelf, alignContent = props.alignContent, flexGrow = props.flexGrow, flexShrink = props.flexShrink, flex = props.flex, _c = props.flexWrap, flexWrap = _c === void 0 ? 'wrap' : _c, flexDirection = props.flexDirection, m = props.m, mr = props.mr, ml = props.ml, mt = props.mt, mb = props.mb, p = props.p, pr = props.pr, pl = props.pl, pt = props.pt, pb = props.pb, className = props.className, rest = __rest(props, ["component", "display", "justifyContent", "alignItems", "alignSelf", "alignContent", "flexGrow", "flexShrink", "flex", "flexWrap", "flexDirection", "m", "mr", "ml", "mt", "mb", "p", "pr", "pl", "pt", "pb", "className"]);
    var direction = (0, styles_1.useTheme)().direction;
    var _d = useStyles({
        display: display,
        justifyContent: justifyContent,
        alignItems: alignItems,
        alignSelf: alignSelf,
        flexGrow: flexGrow,
        flexShrink: flexShrink,
        flex: flex,
        flexWrap: flexWrap,
        flexDirection: flexDirection,
        alignContent: alignContent,
        m: m,
        mr: direction === 'ltr' ? mr : ml,
        ml: direction === 'ltr' ? ml : mr,
        mt: mt,
        mb: mb,
        p: p,
        pr: direction === 'ltr' ? pr : pl,
        pl: direction === 'ltr' ? pl : pr,
        pt: pt,
        pb: pb,
    }), box = _d.box, container = _d.container;
    return react_1.default.createElement(component, __assign({ ref: ref, className: (0, utils_1.cn)(box, container, className) }, rest));
});
